import {Component, OnInit, Inject, LOCALE_ID} from '@angular/core';
import {formatDate} from '@angular/common';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.css']
})


export class ContentHeaderComponent implements OnInit {

    datePipeString: string;

    constructor(@Inject(LOCALE_ID) private locale: string) {
        this.datePipeString = formatDate(Date.now(), 'dd.MM.yyyy', this.locale);

    }

    ngOnInit(): void {
    }

}
